// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"HomeFeedLogisticsModal-3681316c70aaeb57","flexContent":"HomeFeedLogisticsModal-809c4c7c883731c5"};